<template>
  <div
    style="border: 0px solid black; width:100%;"
    v-if="has_perm('view_staff') || GET_ACCOUNT_DATA.id == 1"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchUser(1)"
                  type="text"
                  class="form-control"
                  :placeholder="$t('common.fullNameOrEmail')"
                  v-model="search.searchText"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-mobile"></i>
                  </span>
                  <input
                    v-on:keyup.enter="onSearchUser(1)"
                    type="text"
                    class="form-control"
                    :placeholder="$t('user.phone')"
                    v-model="search.phone"
                  />
                </div>
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchUser(1)"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
            <!-- <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-mobile"></i>
                  </span>
                  <input
                    v-on:keyup.enter="onSearchUser"
                    type="text"
                    class="form-control"
                    :placeholder="$t('user.phone')"
                    v-model="search.phone"
                  />
                </div>
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchUser"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div> -->
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border">
            <div style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;">
              <b>{{ $t("user.title") }}</b>
              <lte-button
                v-if="this.isAdmin() || this.GET_ACCOUNT_DATA.id == 1"
                style="float:right"
                type="btn btn-warning"
                right_icon="fa fa-plus"
                @click="modal_adduser_to_project($event)"
                >{{ $t("user.add") }}</lte-button>
              <lte-button
                v-if="has_perm('create_staff') || this.GET_ACCOUNT_DATA.id == 1"
                style="float:right"
                type="btn btn-primary"
                right_icon="fa fa-plus"
                @click="addNewUser($event)"
                >{{ $t("user.createnew") }}</lte-button>
              <lte-button
                v-if="has_perm('import_staff') || this.GET_ACCOUNT_DATA.id == 1"
                style="float:right;"
                type="btn btn-primary"
                right_icon="fa fa-download"
                @click="importUser($event)"
                >{{ $t("customer.importExcel") }}</lte-button>
            </div>
            <select-option-check
              style="margin-top:-40px;"
              :item="columnsCustomer"
              class="dropdown-trigger"
              data-icon="eye"
              @callbackData="onColumnSelect"
            ></select-option-check>
          </div>

          <div class="box-body">
            <div class="" style="display: flex; padding: 0 15px">
              <span
                v-for="(item, index) in userInPermissionList"
                :key="item+index"
                :class="`${index !== userInPermissionList.length-1 ? 'customer-type-class border-right': 'customer-type-class'}`"
                @click="onChangeCustomerType(item)"
              >
                <span
                  :class="item.value === userInPermissionSelect ? 'customer-type-select' : ''"
                  style="white-space: nowrap;"
                >
                  {{$t(item.text)}} ({{item.total}})
                </span>
              </span>
            </div>
            <lte-table
              v-if="has_perm('view_staff') || GET_ACCOUNT_DATA.id == 1"
              :hdBackground="hdBackground"
              :data="griduserDataList"
              :columns="gridColumns"
              search_filter="left-search"
              @actions="crudActions"
              :useFilter="useFilter"
              :actions="
                GET_ACCOUNT_DATA.id == 1 ||
                (has_perm('update_staff') && has_perm('delete_staff'))
                  ? actions
                  : has_perm('update_staff')
                  ? [actions[0]]
                  : has_perm('delete_staff')
                  ? [actions[1]]
                  : []
              "
              @onClickItemRow="onClickItemRow"
              :row_mouse_pointer="true"
              :boxStyle="boxStyle"
              :customColumns="customColumns"
            >
              ></lte-table
            >
          </div>
        </div>
        <div
          class="box-footer clearfix"
          style="display:contents;"
          v-if="has_perm('view_staff')"
        >
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
        <information-modal id="modal-information-user" :userId="entryId" />
      </row>
    </div>

    <!-- modal-confirm-user-out-of-project -->
    <div class="modal fade" id="modal-confirm-user-out-of-project">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4>
              {{ $t("common.delete_modal.content_with_param") }} email
              {{ user_deleted_email }}
              {{ $t("common.confirm_delete_email_out") }}
            </h4>
          </div>
          <div class="modal-footer">
            <button
              v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('delete_staff')"
              type="button"
              @click="remove_user(user_deleted_id)"
              class="btn btn-primary btn-sm pull-right"
            >
              Xác Nhận
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!-- modal-get-user-to-project -->
    <div
      class="modal fade"
      data-backdrop="static"
      id="modal-get-user-to-project"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t("common.add_user_to_project") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-8 col-md-8 col-lg-8">
                <!-- EMAIL -->
                <b-form-group
                  label-size="sm"
                  label-for="input-sm"
                  :label="'Email'"
                >
                  <div class="form-group">
                    <div>
                      <input class="form-control" v-model="general_email" />
                    </div>
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              :class="'btn btn-primary btn-sm pull-right'"
              @click="onGetUserToProject"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-warning btn-sm pull-left"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <import-user-modal 
      ref="importUserModal"
      @callbackUserList="callbackUserList"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import InformationModal from "@/components/InformationUserModal.vue";
import ImportUserModal from "./ImportUserModal.vue"
import i18n from "../../lang";
import utils from '@/lib/utils';

export default {
  name: "UserList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      general_email: "",
      user_deleted_id: null,
      user_deleted_email: "",
      griduserDataList: [],
      useFilter: false,
      boxStyle: false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "user.code", isHidden: true, wrapText: 'nowrap' },
        // { text: "user.username", isHidden: true },
        { text: "user.fullname", isHidden: true, wrapText: 'nowrap' },
        { text: "user.phone", isHidden: true, wrapText: 'nowrap' },
        { text: "user.gender", isHidden: true },
        { text: "user.email", isHidden: true },
        { text: "user.is_active", isHidden: true },
        { text: "user.privilege", isHidden: true, wrapText: 'nowrap' }
      ],
      customColumns: {
        "user.is_active": {
          true: "btn-label label-success glyphicon glyphicon-ok",
          false: "btn-label label-danger glyphicon glyphicon-remove"
        }
      },
      columnsCustomer: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      actions: ["common.modify", "common.delete"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      paginatorItem: {
        commit_function: "GET_USER_LIST"
      },
      search: {
        code: "",
        username: "",
        searchText: "",
        phone: "",
        gender: "",
        email: "",
        privilege: ""
      },
      isLoading: false,
      entryId: 0,
      userInPermissionList: [
        { value: null, text: 'project.all', total: 0 }
      ],
      userInPermissionSelect: null
    };
  },
  watch: {
    GET_LANG: function() {
      const data = {
        params: {
          page: 1
        }
      };
      this.GET_USER_LIST(data);
    },
    GET_USER_DATA: function() {
      this.griduserDataList = [];
      this.GET_USER_DATA.forEach((user, i) => {
        let nonumber = i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = user.code;
        let username = user.username;
        let id = user.id;
        let fullname = utils.getFullName(
          user.firstname,
          user.lastname,
          i18n.locale
        );
        let lastlogin = user.lastlogin;
        let email = user.email;
        let phone = utils.formatPhoneWithSpace(user.phone, "");
        let gender = this.$t(this.getGender(user.gender))
        let privilege = user.privilege.length > 0 ? user.privilege[0].project_member_role_code : "";
        let data = {
          "common.nonumber": nonumber,
          "user.code": code,
          "user.username": username,
          "user.fullname": utils.capitalizeFirstInString(fullname),
          "user.lastlogin": lastlogin,
          "user.email": email,
          "user.phone": phone,
          "user.gender": gender,
          "user.is_active": user.is_active,
          "user.privilege": `${privilege}`,
          backgroundRow: user.is_blocked ? "#f2404d" : '',
          id: id
        };
        this.griduserDataList.push(data);
      });

      return this.griduserDataList;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsCustomer.data_list = this.gridColumns;
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_USER_DATA",
      "GET_LANG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    getGender(gender) {
      return utils.getGender(gender)
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    isAdmin: function() {
      return utils.isAdmin(this.GET_ACCOUNT_DATA)
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "userlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearchUser: async function(page) {
      const data = {
        params: {
          page: page,
          code: this.search.code,
          username: this.search.username,
          searchText: this.search.searchText,
          phone: this.search.phone,
          gender: this.search.gender,
          email: this.search.email,
          privilege: this.search.privilege,
          projectMemberRoleCode: this.userInPermissionSelect
        }
      };
      this.isLoading = true;
      await this.getNumberUserInPermission()
      this.GET_USER_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    onGetUserToProject: function() {
      let data = {
        email: this.general_email
      };
      this.ADD_USER_TO_PROJECT(data)
        .then(
          function() {
            $("#modal-get-user-to-project").modal("hide");
            this.SUCCESS_TOAST();
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_USER_LIST(data);
          }.bind(this)
        )
        .catch(
          function(error) {
            $("#modal-get-user-to-project").modal("hide");
            let error_message = error.response.data.message;
            if (error_message === "user_existed") {
              this.ON_SHOW_TOAST({
                message: this.$t("customer.error_messages.email_exist_project"),
                styleType: "danger"
              });
            } else if (error_message === "cannot_find_user") {
              this.ON_SHOW_TOAST({
                message: this.$t("customer.error_messages.cannot_find_email"),
                styleType: "danger"
              });
            } else if (error_message === "cannot_find_staff") {
              this.ON_SHOW_TOAST({
                message: this.$t(
                  "customer.error_messages.cannot_find_email_staff"
                ),
                styleType: "danger"
              });
            } else {
              this.ERROR_TOAST();
            }
          }.bind(this)
        );
    },
    remove_user: function(id) {
      this.REMOVE_USER_OUT_PROJECT({ id: id })
        .then(
          function() {
            $("#modal-confirm-user-out-of-project").modal("hide");
            this.SUCCESS_TOAST();
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_USER_LIST(data);
          }.bind(this)
        )
        .catch(
          function() {
            $("#modal-confirm-user-out-of-project").modal("hide");
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    getGroupname(id) {
      if (id === 1) {
        return "Quản Trị";
      } else if (id === 2) {
        return "Người Quản Lý";
      } else if (id === 3) {
        return "Nhân viên";
      } else if (id === 4) {
        return "Khách Hàng";
      } else if (id === 5) {
        return "Người Điều Hành";
      }
      return id;
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    addNewUser: function() {
      this.$router.push({
        name: "UserAdd",
        params: {
          id: 0
        }
      });
    },
    modal_adduser_to_project: function() {
      $("#modal-get-user-to-project").modal("show");
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "UserAdd",
          params: {
            id: recordData.id
          }
        });
      } else if (actionsType == LTEActionTypeEnum.DELETED) {
        this.user_deleted_id = recordData.id;
        this.user_deleted_email = recordData["user.email"];
        $("#modal-confirm-user-out-of-project").modal("show");
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_USER_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_USER_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      const filter = {
        params: {
          page: data.params.page
        }
      };
      this.GET_USER_LIST(filter);
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "REMOVE_USER_OUT_PROJECT",
      "GET_USER_LIST",
      "ADD_USER_TO_PROJECT",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_NUMBER_USER_IN_PERMISSION",
      "GET_MEMBERROLECODES"
    ]),
    onClickItemRow: function(entryId) {
      this.entryId = entryId;
      $("#modal-information-user").modal("show");
    },
    onChangeCustomerType: function(data) {
      this.userInPermissionSelect = data.value
      this.onSearchUser(1)
    },
    getNumberUserInPermission: function() {
      const data = {
        params: {
          code: this.search.code,
          username: this.search.username,
          searchText: this.search.searchText,
          phone: this.search.phone,
          gender: this.search.gender,
          email: this.search.email,
          privilege: this.search.privilege,
        }
      }
      this.GET_NUMBER_USER_IN_PERMISSION(data)
        .then(
          function(res) {
            let data = res.data
            data.forEach((value, index) => {
              this.userInPermissionList[index].total = value
            })
          }.bind(this)
        )
    },
    importUser: function() {
      this.$refs.importUserModal.onShowImport()
    },
    callbackUserList: function() {
      let currentPage = this.PAGINATION.page;
      let totalPage = this.PAGINATOR.length;
      let page =
        currentPage >= totalPage && this.griduserDataList.length == 1
          ? totalPage >= 2 ? totalPage - 1 : 1
          : currentPage;
      this.onSearchUser(page)
    }
  },
  async mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_USER_LIST(data);
    this.columnsCustomer.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "userlist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.userInPermissionList = [
      { value: null, text: 'project.all', total: 0 }
    ]
    let memberRoleCodeFilter = {
      params: {
        isCustomer: false
      }
    };
    await this.GET_MEMBERROLECODES(memberRoleCodeFilter)
      .then(
        function(res) {
          let data = res.data
          data.forEach((value, index) => {
            this.userInPermissionList.push({
              value: value.id, text: value.name, total: 0
            })
          })
        }.bind(this)
      )
    await this.getNumberUserInPermission()
  },

  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "information-modal": InformationModal,
    "select-option-check": SelectOptionCheck,
    ImportUserModal
  }
};
</script>
<style scoped>
.customer-type-class{
  padding: 5px 15px;
  cursor: pointer;
}
.border-right{
  border-right: 1px solid #000000;
}
.customer-type-select {
  font-weight: bold;
  color: #006ad4;
}
</style>



// WEBPACK FOOTER //
// src/views/User/UserList.vue